import { render, staticRenderFns } from "./IllustrationPureColorsceneSection.vue?vue&type=template&id=1f691506"
import script from "./IllustrationPureColorsceneSection.vue?vue&type=script&lang=ts"
export * from "./IllustrationPureColorsceneSection.vue?vue&type=script&lang=ts"
import style0 from "./IllustrationPureColorsceneSection.vue?vue&type=style&index=0&id=1f691506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports